import React from 'react';

export const ArticleIFrame: React.FC<{ articleBody: string }> = ({ articleBody }) => {
  return (
    <div className="mx-auto flex min-h-[90vh] w-full flex-1 flex-grow items-stretch">
      <iframe className="article-body w-full flex-1" srcDoc={articleBody} title="Article body" />
    </div>
  );
};
